// extracted by mini-css-extract-plugin
export default {"container":"CY00s","component":"y94CG","component--no-grow":"rSqEv"};